module.exports = __webpack_public_path__ + "img/QR.7f4183b6.png";